export default __webpack_public_path__ + "static/invoice-with-tablet-133b0b61046fcad6bbdb3e39fce02f56.png";